import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { toValidator } from 'renderer/shared/schemas/common.schemas';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import { RefundForm, RefundFormSchema } from '../schemas/refund.schemas';
import { useRefundTransactionMutation } from '../services/transactions.endpoints';
import { BaseTransaction } from '../schemas/transaction.schemas';

interface RefundDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  transaction: BaseTransaction | null;
}

const RefundDialog: React.FC<RefundDialogProps> = ({
  open,
  setOpen,
  transaction,
}) => {
  const [refundTransaction, { error, isSuccess }] =
    useRefundTransactionMutation();

  if (!transaction) return null;

  const initialForm: RefundForm = {
    amount: transaction.amount,
    note: '',
  };
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Issue Refund</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{formatQueryError(error)}</Alert>}
        {isSuccess && (
          <Alert severity="success">Successfully processed refund!</Alert>
        )}
        <Formik
          initialValues={initialForm}
          validate={toValidator(RefundFormSchema)}
          onSubmit={(values) =>
            refundTransaction({ ...values, transactionId: transaction._id })
          }
        >
          <Form>
            <Field
              component={TextField}
              name="amount"
              label="Amount ($)"
              type="number"
              fullWidth
              margin="dense"
            />
            <Field
              component={TextField}
              name="note"
              label="Note"
              fullWidth
              margin="dense"
            />
            <Button variant="contained" color="primary" type="submit">
              Issue Refund
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </Form>
        </Formik>
      </DialogContent>
      {/* <DialogActions>
      </DialogActions> */}
    </Dialog>
  );
};

export default RefundDialog;
